// Karte (Kontaktseite): passt die vom geolocation-AddOn erzeugte Leaflet-Karte an –
// Marken-Pin, Zoom-Nav unten rechts, Anschrift als Popup bei Pin-Klick.
// Das <rex-map>-Element initialisiert die Karte bereits im connectedCallback (beim
// Parsen, VOR diesem defer-Script) und legt sie unter element.__rmMap.map ab – daher
// holen wir die Map direkt vom Element (Poll-Fallback + Event für späte Init nach
// Consent). Leaflet (`L`) ist dann global. Kein Inline-JS (§8).
export function initKarte() {
  document.querySelectorAll(".karte").forEach((root) => {
    const mapEl = root.querySelector(".karte__map");
    const rexMap = root.querySelector("rex-map");
    const popup = root.querySelector("[data-karte-popup]");
    const closeBtn = root.querySelector("[data-karte-close]");
    if (!mapEl) return;

    const openPopup = () => popup && (popup.hidden = false);
    const closePopup = () => popup && (popup.hidden = true);
    if (closeBtn) closeBtn.addEventListener("click", closePopup);

    // Wendet Pin, Zoom-Position und Popup-Verdrahtung an. Gibt true zurück, sobald
    // die Karte inkl. Marker bereit war (dann kann das Polling stoppen).
    const customize = (map) => {
      if (!map || typeof L === "undefined") return false;

      // Zoom-Control nach unten rechts (nur +/- sichtbar, Extras via CSS ausgeblendet).
      const zoom = map._container.querySelector(".geolocation-control");
      if (zoom && map._controlCorners && map._controlCorners.bottomright) {
        map._controlCorners.bottomright.appendChild(zoom);
      }

      // Attribution nach unten LINKS – sonst klebt sie über der Zoom-Nav (bottomright).
      const attr = map._container.querySelector(".leaflet-control-attribution");
      if (attr && map._controlCorners && map._controlCorners.bottomleft) {
        map._controlCorners.bottomleft.appendChild(attr);
      }

      // Marken-Pin als Marker-Icon; Klick auf den Pin öffnet das Anschrift-Popup.
      const pinUrl = mapEl.dataset.pin;
      const icon = pinUrl
        ? L.icon({
            iconUrl: pinUrl,
            iconSize: [46, 60],
            iconAnchor: [23, 60],
            className: "karte__pin",
          })
        : null;

      let hasMarker = false;
      map.eachLayer((layer) => {
        if (layer instanceof L.Marker) {
          hasMarker = true;
          if (icon) layer.setIcon(icon);
          layer.off("click", openPopup);
          layer.on("click", openPopup);
        }
      });
      return hasMarker;
    };

    const getMap = () =>
      (rexMap && rexMap.__rmMap && rexMap.__rmMap.map) || null;

    // Direkter Zugriff + kurzer Poll-Fallback (Marker wird ggf. minimal später gesetzt).
    let tries = 0;
    const tick = () => {
      if (customize(getMap())) return;
      if (tries++ < 40) requestAnimationFrame(tick);
    };
    tick();

    // Falls die Karte erst später initialisiert (z. B. nach Consent): Event abfangen.
    mapEl.addEventListener("geolocation:dataset.ready", (e) => {
      customize(e.detail && e.detail.map);
    });
  });
}
